module.exports = __webpack_public_path__ + "static/media/saxophone.4fec3361.wav";